module.exports = __webpack_public_path__ + "img/process.986fe1d9.png";